










































// vue
import {Vue, Component, Watch} from 'vue-property-decorator';
import {Mutation} from 'vuex-class';
import {State} from 'vuex-class';

import {getLocalStorage} from '@/utils/local-storage';


@Component({

})
export default class TheHeader extends Vue {
  public isShowMenu: boolean = false;
  public logo: string = '';


  @State('companyInfo')
  public companyInfo!: any;

  @State('navInfo')
  public navInfo!: any;

  @Mutation('setNavInfo')
  public setNavInfo!: (data: any) => void;

  @Watch('isShowMenu')
  public watchIsShowMenu(value: boolean, oldValue: boolean) {
    switch (value) {
      case true:
        window.document.body.style.overflow = 'hidden';
        break;
      case false:
        window.document.body.style.overflow = 'unset';
        break;
    }
  }

  public mounted() {
    if (!this.navInfo.length) {
      const localNavInfo = window.localStorage.getItem('navInfo');
      const localNavInfoObj = localNavInfo ? JSON.parse(localNavInfo) : null;

      if (localNavInfoObj) {
        this.setNavInfo(localNavInfoObj);
      }
    }

    if (!this.companyInfo.imgUrl) {
      const localStorageData = getLocalStorage();
      const {companyInfo} = localStorageData;
      if (companyInfo) {
        const companyInfoObj = companyInfo;
        this.logo = companyInfoObj.imgUrl;
      }
    } else {
      this.logo = this.companyInfo.imgUrl;
    }
  }

  // 返回
  public back() {
    this.$router.back();
  }

  // 切换菜单
  public switchMenu() {
    this.isShowMenu = !this.isShowMenu;
  }

  // 隐藏菜单
  public hiddenMenu() {
    this.isShowMenu = false;
  }

  // 前往页面
  public toPage(item: any, index: number) {
    const {catType, id, outUrl} = item;

    if (outUrl) {
      if ((<string> outUrl).startsWith('http://') || (<string> outUrl).startsWith('https://')) {
        window.location.assign(outUrl);
      } else {
        window.location.assign('http://'.concat(outUrl));
      }

      return false;
    }

    switch (catType) {
      // 根目录
      case '0':
        this.$router.push({
          path: '/root-col',
          query: {
            data: JSON.stringify(item),
          },
        });
        break;
      // 新闻列表
      case '1':
        this.$router.push({
          path: '/news',
          query: {
            data: JSON.stringify(item),
          },
        });
        break;
      // 图文详情
      case '2':
        this.$router.push({
          path: '/news-article',
          query: {
            data: JSON.stringify(item),
          },
        });
        break;
      // 留言反馈
      case '3':
        this.$router.push({
          path: '/advise',
        });
        break;
      // 留言反馈
      case '10':
        this.$router.push({
          path: '/',
        });
        break;
    }
  }
}
